import React from 'react';
import './Offering.css';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';





const Online = () => {
    return (
        <>
        <Helmet>
                    <title>Online Ernährungsberatung und Ernährungstherapie</title>
                    <meta name="description" content='Online Beratungen werden von den gesetlichen Krankenkassen ebenfalls bezuschusst bzw. vollständig übernommen. Nach Erhalt der Kostenzusage durch ihre Krankenkasse, kontaktieren Sie mich bitte per Mail oder 
                    Telefon für die Terminvereinbarung der Erstberatung.' />
                </Helmet>
        <div className='Therapie'>
            <div className="BeratungWrapper">
                <div className='entrycontent'>

                    <h2 className='header'>Online Ernährungsberatung und Ernährungstherapie</h2>

                    <p className='text'>Für die Bezuschussung der Online Beratung gilt der unter <Link to={"/Kostenuebernahme"} className="showLink">Kostenübernahme</Link> beschriebene Weg. Sobald Sie die Kostenzusage von Ihrer Krankenkasse erhalten habe,
                        kontaktieren Sie mich bitte per Mail oder Telefon und wir vereinbaren einen Termin zur Erstberatung.
                        Danach sende ich Ihnen einen Link den Sie nur anzuklicken brauchen, Sie müssen nichts installieren oder herunterladen.
                        Meine Materialien sind digitalisiert und nach der Beratung sende ich Ihnen die besprochenen Unterlagen per e-Mail.</p>

                </div>

            </div >

        </div>
        </>);
}

export default Online;
